import React from 'react';

const AVATAR_COLORS = [
  'bg-blue-500',
  'bg-purple-500',
  'bg-emerald-500',
  'bg-orange-500',
  'bg-pink-500',
  'bg-teal-500',
  'bg-indigo-500',
  'bg-rose-500',
  'bg-amber-500',
  'bg-cyan-500'
];

export const getEmployeeInitials = (name: string | null | undefined): string => {
  if (!name?.trim()) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const getEmployeeColor = (name: string | null | undefined): string => {
  if (!name) return AVATAR_COLORS[0];
  const hash = name.split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};

const SIZE_CLASSES = {
  sm: 'w-6 h-6 text-xs',
  md: 'w-8 h-8 text-sm',
  lg: 'w-10 h-10 text-base'
};

interface IProps {
  name: string | null | undefined;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const EmployeeAvatar: React.FC<IProps> = ({ name, size = 'md', className = '' }) => (
  <div
    className={`${SIZE_CLASSES[size]} ${getEmployeeColor(name)} rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0 select-none ${className}`}
    title={name ?? undefined}
  >
    {getEmployeeInitials(name)}
  </div>
);

export default EmployeeAvatar;
